<template>
  <div class="container py-5">
    <v-form 
      :valid.sync="valid" 
      class="columns is-multiline">

      <div class="column is-one-third">

        <div class="field">
          <div class="label-and-button pb-2">
            <label class="label mb-0">Ticket Category*</label>
            <span 
              class="tag pointer" 
              @click="managingCategories = true">
              <span class="icon is-small">
                <i class="fas fa-plus"></i>
              </span>
              <span>Manage Categories</span>
            </span>
          </div>
          <v-select
            v-if="categories.length > 0"
            required
            item-text="category"
            item-value="id"
            :options="categories"
            v-model="ticket.category_id"
          />
          <div v-else class="has-text-grey py-2">
            No categories available
          </div>
        </div>

        <div class="field">
          <label class="label">Ticket Priority*</label>
          <v-select
            required
            :options="priorities"
            v-model="ticket.priority"
          />
        </div>

        <div class="field">
          <label class="label">File Upload</label>
          <v-drop-zone
            height="120px"
            id='ticket-attachment'
            :file-name.sync="upload.name"
            v-model="upload.file">
          </v-drop-zone>
        </div>

      </div>

      <div class="column is-two-thirds">

        <div class="field">
          <label class="label">Ticket Title*</label>
          <v-text-field
            required
            v-model="ticket.title">
          </v-text-field>
        </div>

        <div class="field">
          <label class="label">Ticket Description</label>
          <v-rich-text
            min-height="170px"
            v-model="ticket.desc">
          </v-rich-text>
        </div>

      </div>
    </v-form>

    <button
      :disabled="!valid"
      @click="addNewTicket()"
      class="button is-primary mt-5">
      Submit Ticket
    </button>

    <manage-categories-modal 
      v-model="managingCategories"/>

  </div>
</template>

<script>
import VTextField from '@/components/base/VTextField'
import VSelect from '@/components/base/VSelect'
import VForm from '@/components/base/VForm'
import VRichText from '@/components/base/VRichText'
import VDropZone from '@/components/base/VDropZone'
import ManageCategoriesModal from '@/components/ticketing/ManageCategoriesModal'

import { mapState, mapActions } from 'vuex'

export default {
  components: {
    VTextField,
    VSelect,
    VForm,
    VRichText,
    VDropZone,
    ManageCategoriesModal
  },
  data() {
    return {
      priorities: ['Low', 'Medium', 'High'],
      ticket: {
        admin_assigned: null,
        title: null,
        desc: null,
        category: null,
        priority: null
      },
      upload: {
        file: null,
        name: null
      },
      valid: false,
      managingCategories: false
    }
  },
  computed: { 
    ...mapState("tickets", ["categories"]) 
  },
  methods: {
    ...mapActions("tickets", ["addTicket", "attachImage"]),
    addNewTicket() {
      this.addTicket({ data: this.ticket }).then(resp => {
        if (this.upload.file) {
          let formData = new FormData();
          formData.append('images', this.upload.file, this.upload.file.name);

          this.attachImage({ ticketId: resp.data.id, data: formData }).then(
            () => this.goToList()
          );
        } else {
          this.goToList();
        }
      })
    },
    goToList() {
      this.$router.push({ name: 'Tickets' });
    }
  }
}
</script>

<style lang="scss" scoped>
.label-and-button {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  .tag {
    cursor: pointer;
    &:hover {
      background: gainsboro;
    }
  }
}
</style>